<template>
    <div>
        <PullContainer
            ref="pullContainerRef"
            :pullDownLoading="true"
            :pullDownLabel="true"
            @pullDownLoadingSuccess="pullDownLoadingSuccess"
        >
            <template #container>
                <div class="public_container">
                    <div class="returnNavBar">
                        <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true"></ReturnNavBar>
                    </div>
                    <div class="top_search">
                        <van-search
                            v-model="searchForm.keyword"
                            placeholder="请输入查询内容"
                            @search="onSearch"
                            @clear="onSearch"
                        >
                        </van-search>
                    </div>
                    <div class="all_menu_list">
                        <ul>
                            <li
                                v-for="item in tabList"
                                :key="item.name"
                                :class="{ active: tabActiveName == item.name }"
                                @click="handleClickTab(item)"
                            >
                                <span>{{ item.label }}</span>
                            </li>
                        </ul>
                        <div class="all_menu_filter_icon" @click="handleClickCategoryPickerShow">
                            <img
                                src="https://download.hecoos.com/enlightv/2024-51/4c642c0c14402f868ad37bc896bb25fb.png"
                                alt=""
                            />
                        </div>
                    </div>
                    <div class="mobile_container">
                        <div class="finance_filter">
                            <div class="finance_filter_right" @click="timeRadioPicker = true">
                                <span v-text="timeTypeList.find((item) => item.value === filterTimeType).name"></span>
                                <i class="el-icon-caret-bottom"></i>
                            </div>
                        </div>
                        <ul class="static_num_top">
                            <template v-if="tabActiveName == 'payableSummary'">
                                <li>
                                    <p>应付汇总金额</p>
                                    <p>
                                        {{ Number(summaryData.summary_data && summaryData.summary_data.total_payable_amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                                    </p>
                                </li>
                                <li>
                                    <p>已付汇总金额</p>
                                    <p>{{Number(summaryData.summary_data && summaryData.summary_data.total_paid_amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</p>
                                </li>
                                <li>
                                    <p>应付未付汇总金额</p>
                                    <p>
                                        {{ Number(summaryData.summary_data && summaryData.summary_data.total_unpaid_amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                                    </p>
                                </li>
                                <li>
                                    <p>取消汇总金额</p>
                                    <p>
                                        {{ Number(summaryData.summary_data && summaryData.summary_data.total_canceled_amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                                    </p>
                                </li>
                            </template>
                            <template v-else-if="tabActiveName == 'purchase'">
                                <li>
                                    <p>采购应付总金额</p>
                                    <p>
                                        {{ Number(summaryData.summary_data && summaryData.summary_data.total_payable_amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                                    </p>
                                </li>
                                <li>
                                    <p>采购已付总金额</p>
                                    <p>{{ Number(summaryData.summary_data && summaryData.summary_data.total_paid_amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</p>
                                </li>
                                <li>
                                    <p>采购未付总金额</p>
                                    <p>
                                        {{ Number(summaryData.summary_data && summaryData.summary_data.total_unpaid_amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                                    </p>
                                </li>
                                <li>
                                    <p>取消总金额</p>
                                    <p>
                                        {{ Number(summaryData.summary_data && summaryData.summary_data.total_canceled_amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                                    </p>
                                </li>
                            </template>
                            <template v-else-if="tabActiveName == 'order_return'">
                                <li>
                                    <p>订单退款应付总金额</p>
                                    <p>
                                        {{ Number(summaryData.summary_data && summaryData.summary_data.total_payable_amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                                    </p>
                                </li>
                                <li>
                                    <p>订单退款已付总金额</p>
                                    <p>{{ Number(summaryData.summary_data && summaryData.summary_data.total_paid_amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</p>
                                </li>
                                <li>
                                    <p>订单退款未付总金额</p>
                                    <p>
                                        {{ Number(summaryData.summary_data && summaryData.summary_data.total_unpaid_amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                                    </p>
                                </li>
                                <li>
                                    <p>订单退款取消总金额</p>
                                    <p>
                                        {{ Number(summaryData.summary_data && summaryData.summary_data.total_canceled_amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                                    </p>
                                </li>
                            </template>
                            <template v-else>
                                <li>
                                    <p>{{ chartTooltipTitle }}应付总金额</p>
                                    <p>
                                        {{ Number(summaryData.summary_data && summaryData.summary_data.total_payable_amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                                    </p>
                                </li>
                                <li>
                                    <p>{{ chartTooltipTitle }}已付总金额</p>
                                    <p>{{ Number(summaryData.summary_data && summaryData.summary_data.total_paid_amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</p>
                                </li>
                                <li>
                                    <p>{{ chartTooltipTitle }}未付总金额</p>
                                    <p>
                                        {{ Number(summaryData.summary_data && summaryData.summary_data.total_unpaid_amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                                    </p>
                                </li>
                                <li>
                                    <p>{{ chartTooltipTitle }}取消总金额</p>
                                    <p>
                                        {{ Number(summaryData.summary_data && summaryData.summary_data.total_canceled_amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                                    </p>
                                </li>
                            </template>
                        </ul>
                        <div class="chart_box">
                            <div class="chart_box_time_type">
                                <span
                                    v-for="item in chartDateTypeList"
                                    :key="item.type"
                                    :class="{ active: chartDateType === item.type }"
                                    @click="handleClickChartType(item.type)"
                                    >{{ item.name }}</span
                                >
                            </div>
                            <div class="echarts_container" id="container1"></div>
                        </div>
                        <div class="chart_box pie_chart_box">
                            <div class="echarts_container" id="container2"></div>
                        </div>
                        <ul class="list_wrap">
                            <li class="list_item" v-for="row in summaryData.list_data">
                                <p>
                                    <template v-if="tabActiveName == 'payableSummary'">
                                        <span v-if="row.entity_type == 'customer'" class="link-label"  @click="handleClickCustomerDetail(row.entity_id, row.entity_name)">{{
                                            row.entity_name || "--"
                                        }}</span>
                                        <span v-else>{{ row.entity_name || "--" }}</span>
                                    </template>
                                    <span v-else-if="tabActiveName === 'purchase'">{{
                                        row.supplier_name || "--"
                                    }}</span>
                                    <span
                                        v-else-if="tabActiveName === 'order_return'"
                                        class="link-label"
                                        @click="handleClickCustomerDetail(row.customer_id, row.customer_name)"
                                        >{{ row.customer_name || "--" }}</span
                                    >
                                    <span v-else>{{ row.payee_name || "--" }}</span>
                                </p>
                                <div class="list_item_amount">
                                    <div>
                                        <div class="list_item_amount_percent percent_bg1">
                                            应付总金额：¥{{ row.total_payable_amount }}
                                        </div>
                                    </div>
                                    <div>
                                        <div class="list_item_amount_percent percent_bg2">
                                            已付总金额：¥{{ row.total_paid_amount }}
                                        </div>
                                        <div
                                            class="list_item_amount_percent percent_bg4"
                                            v-if="row.total_unpaid_amount"
                                        >
                                            未付总金额：¥{{ row.total_unpaid_amount }}
                                        </div>
                                    </div>
                                </div>
                                <div class="list_item_bottom">
                                    <span @click="handleClickDetail(row)">明细<van-icon name="arrow" /></span>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <FooterTabbar :tabBarList="tabBarList" :tabBarActive="tabBarActive"></FooterTabbar>
                </div>
            </template>
        </PullContainer>
        <!-- 应付统计菜单类型选择 -->
        <van-overlay
            :custom-style="{ background: 'rgba(0, 0, 0, 0.3)' }"
            class-name="custom_more_overlay"
            v-if="showTabPicker"
            :show="showTabPicker"
            @click="showTabPicker = false"
        >
            <div class="radio_option_wrap">
                <div class="radio_option_item" @click="handleClickCategoryPickerClose">
                    <span>应付统计分类</span>
                    <van-icon name="arrow-up" />
                </div>
                <ul class="radio_option_list">
                    <li
                        class="radio_option_item"
                        v-for="item in tabList"
                        :key="item.name"
                        @click="handleClickTab(item)"
                    >
                        <span>{{ item.label }}</span>
                        <van-icon name="success" v-if="tabActiveName == item.name" />
                    </li>
                </ul>
            </div>
        </van-overlay>
        <van-overlay
            :custom-style="{ background: 'rgba(0, 0, 0, 0.3)' }"
            v-if="timeRadioPicker"
            :show="timeRadioPicker"
        >
            <div class="custome_radio_option_wrap">
                <ul class="radio_option_list">
                    <li
                        v-for="item in timeTypeList"
                        class="radio_option_item"
                        @click="handleClickTimeOption(item)"
                        v-text="item.name"
                    ></li>
                </ul>
                <div class="cancel_btn" @click="timeRadioPicker = false">取消</div>
            </div>
        </van-overlay>
        <van-calendar
            v-model="customDateVisible"
            :allow-same-day="true"
            :max-date="dateCalendarMax"
            :min-date="dateCalendarMin"
            title="选择时间"
            color="#1990FF"
            type="range"
            confirm-text="确认"
            @confirm="handleClickRangeCalendarConfirm"
        >
        </van-calendar>
    </div>
</template>
<script>
import * as echarts from "echarts";
import {
    PayableSourceList,
    PayablePurchaseSummary,
    PayableOrderRefundSummary,
    PayableApprovalSummary,
    PayableSummary,
} from "@/api";
import { getDateRange, formatDate } from "@/utils";
import PullContainer from "@/components/mComponents/PullContainer.vue";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import FooterTabbar from "@/components/mComponents/FooterTabbar.vue";
export default {
    name: "PayableStatistics",
    components: {
        PullContainer,
        ReturnNavBar,
        FooterTabbar,
    },
    data() {
        return {
            searchForm: {
                keyword: "",
                date_range: "",
            },
            tabActiveName: "payableSummary",
            tabList: [
                { name: "payableSummary", label: "应付汇总", chartTitle: "全部应付汇总金额" },
                // { name: "purchase", label: "采购应付统计", chartTitle: "采购应付金额趋势" },
                // { name: "order_return", label: "订单退款应付统计", chartTitle: "订单退款应付金额趋势" },
                // { name: "group1", label: "应付控件组", chartTitle: "" },
                // { name: "group2", label: "应付控件组", chartTitle: "" },
                // { name: "group3", label: "应付控件组", chartTitle: "" },
            ],
            filterTimeType: "month",
            timeTypeList: [
                { value: "month", name: "本月" },
                { value: "quarter", name: "本季度" },
                { value: "year", name: "本年" },
                { value: "custom", name: "自定义" },
            ],
            timeRadioPicker: false,
            showTabPicker: false,
            // 图表切换
            chartDateType: "day",
            chartDateTypeList: [
                { name: "日", type: "day" },
                { name: "周", type: "week" },
                { name: "月", type: "month" },
            ],
            // 自定义时间选择
            customDateVisible: false,
            dateCalendarMin: new Date("2015-01-01"),
            dateCalendarMax: new Date("2070-01-01"),
            // 统计数据
            summaryData: {
                total_payable_amount: ".00", // 应付总金额
                total_paid_amount: "", // 已付总金额
                total_unpaid_amount: "", // 未付总金额
                total_canceled_amount: "", //取消总金额
                summary_data: {
                    total_payable_amount: "", // 应付总金额
                    total_paid_amount: "", // 已付总金额
                    total_unpaid_amount: "", // 未付总金额
                    total_canceled_amount: "", //取消总金额
                },
                trend_data: [], // 柱状图数据
                pie_data: [], // 饼图
                list_data: [], // 表格数据
            },
            tabBarList: [
                {
                    icon: "icon-shouye",
                    activeIcon: "icon-shouyexuanzhong",
                    routerName: "FinanceManagement",
                    title: "首页",
                },
                {
                    icon: "icon-mobile-yingfu",
                    activeIcon: "icon-mobile-yingfu",
                    routerName: "PayableManage",
                    title: "应付",
                },
                {
                    icon: "icon-yingshou",
                    activeIcon: "icon-yingshouxuanzhong",
                    routerName: "ReceivableManage",
                    title: "应收",
                },
                {
                    icon: "icon-shouye",
                    activeIcon: "icon-shouyexuanzhong",
                    routerName: "InvoiceManage",
                    title: "开票",
                },
            ],
            tabBarActive: 1,
        };
    },
    created() {
        const end = new Date();
        const start = new Date(end.getFullYear(), end.getMonth(), 1);
        this.searchForm.date_range = [formatDate(start, "date"), formatDate(end, "date")];
        this.getPayableSourceList();
    },
    methods: {
        pullDownLoadingSuccess(flag) {
            if (flag) {
                this.pullDownLoading = true;
                this.onSearch();
            }
        },
        // 应付来源
        getPayableSourceList() {
            PayableSourceList().then((res) => {
                if (res.code === 200) {
                    let data = res.data || [];
                    if (data.length) {
                        const tabData = data.map((item) => {
                            return {
                                name: item.source_type == "approval" ? item.source_type + item.id : item.source_type,
                                label: item.name + "统计",
                                chartTitle:
                                    item.source_type == "purchase"
                                        ? "采购应付金额趋势"
                                        : item.source_type == "order_return"
                                        ? "订单退款应付金额趋势"
                                        : item.name + "应付金额",
                                chartTooltipTitle: item.name,
                                id: item.id,
                            };
                        });
                        this.tabList = this.tabList.concat(tabData);
                    }
                    this.$nextTick(() => {
                        this.onSearch();
                    });
                }
            });
        },
        // 分类切换弹框
        handleClickCategoryPickerShow() {
            this.showTabPicker = true;
        },
        handleClickTab(item) {
            this.tabActiveName = item.name;
            const findTab = this.tabList.find((item) => item.name == this.tabActiveName);
            this.source_id = findTab?.id;
            this.source_name = findTab?.label;
            this.chartTooltipTitle = findTab?.chartTooltipTitle;
            this.$nextTick(() => {
                this.onSearch();
            });
        },
        // 时间范围选择
        handleClickTimeOption(item) {
            if (item.value == "custom") {
                this.customDateVisible = true;
            } else {
                this.searchForm.date_range = getDateRange(item.value).split(" - ");
                this.onSearch();
            }
            this.filterTimeType = item.value;
            this.timeRadioPicker = false;
        },
        //日期区间确定事件
        handleClickRangeCalendarConfirm(range) {
            const [start, end] = range;
            let value = [formatDate(start, "date"), formatDate(end, "date")];
            this.searchForm.date_range = value;
            this.customDateVisible = false;
            this.onSearch();
        },
        // 图表日期类型切换
        handleClickChartType(type) {
            this.chartDateType = type;
            this.$nextTick(()=> {
                this.onSearch()
            })
        },
        onSearch() {
            this.summaryData.list_data = [];
            this.summaryData.trend_data = [];
            this.summaryData.pie_data = [];
            if (this.tabActiveName == "purchase") {
                this.getPayablePurchaseSummary();
            } else if (this.tabActiveName == "order_return") {
                this.getPayableOrderRefundSummary();
            } else if (this.tabActiveName == "payableSummary") {
                this.getPayableSummary();
            } else {
                this.getPayableApprovalSummary();
            }
        },
        // 采购应付统计
        getPayablePurchaseSummary() {
            const params = {
                // source_id: this.source_id,
                keyword: this.searchForm.keyword,
                date_range: this.searchForm.date_range,
                chart_time_type: this.chartDateType
            };
            PayablePurchaseSummary(params).then((res) => {
                if (res.code === 200) {
                    this.summaryData = res.data || {};
                    this.getBarData(this.summaryData.trend_data, "采购应付金额");
                }
            });
        },
        // 订单退款应付统计
        getPayableOrderRefundSummary() {
            const params = {
                // source_id: this.source_id,
                keyword: this.searchForm.keyword,
                date_range: this.searchForm.date_range,
                chart_time_type: this.chartDateType
            };
            PayableOrderRefundSummary(params).then((res) => {
                if (res.code === 200) {
                    this.summaryData = res.data || {};
                    this.getBarData(this.summaryData.trend_data, "订单退款应付金额");
                }
            });
        },
        // 应付控件组统计
        getPayableApprovalSummary() {
            const params = {
                source_id: this.source_id,
                keyword: this.searchForm.keyword,
                date_range: this.searchForm.date_range,
                chart_time_type: this.chartDateType
            };
            PayableApprovalSummary(params).then((res) => {
                if (res.code === 200) {
                    this.summaryData = res.data || {};
                    this.getBarData(this.summaryData.trend_data, this.chartTooltipTitle + "应付金额");
                }
            });
        },
        // 应付汇总
        getPayableSummary() {
            const params = {
                keyword: this.searchForm.keyword,
                date_range: this.searchForm.date_range,
                chart_time_type: this.chartDateType
            };
            PayableSummary(params).then((res) => {
                if (res.code === 200) {
                    this.summaryData = res.data || {};
                    this.getBarData(this.summaryData.trend_data, "汇总金额");
                    this.getPieData(this.summaryData.pie_data);
                }
            });
        },
        getBarData(data, tooltipName) {
            let xData = data.map((item) => item.operate_date);
            let sData = data.map((item) => item.total_amount);

            var charts = document.getElementById("container1");
            var myChart = echarts.getInstanceByDom(charts);
            if (myChart) {
                myChart.dispose();
            }
            this.getEchartsBar("container1", xData, sData, tooltipName);
        },
        getEchartsBar(id, xData, sData, tooltipName) {
            var dom = document.getElementById(id);
            this.myChartBar = echarts.init(dom);
            this.myChartBar.clear();
            var color = ["#1890ff", "#52C41B", "#FBAD13", "#FF4D4F", "#00BAAD"];
            var option;
            option = {
                color,
                grid: {
                    left: "10px",
                    top: "10px",
                    right: "10px",
                    bottom: "0",
                    containLabel: true,
                },
                tooltip: {
                    trigger: "item",
                    axisPointer: {
                        // 坐标轴指示器，坐标轴触发有效
                        type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
                    },
                    triggerOn: "mousemove", // 鼠标移动时触发 tooltip
                    enterable: true,
                    zIndex: 1000, // 提高 tooltip 的层级
                    backgroundColor: "#fffffff",
                    padding: 12,
                    position: function (point, params, dom, rect, size) {
                        return [point[0], point[1]];
                    },
                    formatter: function (params) {
                        let html = `<div class="custom_chart_tooltip"><p class="tooltip_title">${
                            params.name
                        }</p><p class="tooltip_content"><span>${tooltipName}</span><span class="count">${
                            params.data + "元"
                        }</span></p></div>`;
                        return html;
                    },
                },
                dataZoom: [
                    {
                        type: 'slider', // 使用滑块类型
                        start: 0, // 初始化滑块开始位置（百分比）
                        bottom: 0,
                        height: 15,
                        handleSize: '100%', // 滑块手柄的大小
                        handleStyle: {
                            color: '#000',
                            shadowBlur: 3,
                            shadowColor: 'rgba(0, 0, 0, 0.6)',
                            shadowOffsetX: 2,
                            shadowOffsetY: 2
                        }
                    },
                    {
                        type: 'inside', // 使用滑块类型
                        start: 0, // 初始化滑块开始位置（百分比）
                    }
                ],
                xAxis: {
                    type: "category",
                    data: xData,
                    axisLabel: {
                        interval: 0,
                        rotate: 0,
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLabel: {
                        color: "#000000FF",
                    },
                },
                yAxis: {
                    type: "value",
                    name: "", // 设置 y 轴标题
                    min: 0, // 设置最小值
                    scale: true, // 允许动态缩放
                    axisLine: {
                        show: false,
                    },
                    splitLine: {},
                    axisTick: {
                        show: false,
                    },
                    axisLabel: {
                        color: "rgba(0,0,0,.45)",
                        formatter: function (value) {
                            return value + "元";
                        },
                    },
                },
                series: [
                    {
                        data: sData,
                        type: "bar",
                    },
                ],
            };
            if (option && typeof option === "object") {
                this.myChartBar.setOption(option, true);
            }
            this.handleResize();
            window.addEventListener("resize", this.handleResize);
        },
        // toTenThousand(value) {
        //     const wan = value / 10000;
        //     // 检查是否为整数
        //     if (wan % 1 === 0) {
        //         return wan;
        //     } else {
        //         // 可能需要保留两位小数，但去掉末尾的零
        //         let fixed = wan.toFixed(2);
        //         // 去掉末尾的零和小数点
        //         fixed = fixed.replace(/\.?0+$/, "");
        //         return fixed;
        //     }
        // },
        getPieData(list) {
            let data = list.map((item) => ({
                ...item,
                value: Math.abs(item.total_amount), // 使用绝对值,因为有的数据存在负数

            }));
            let sData = [];
            let sData2 = [];
            const color = [
                "#2990FF",
                "#F0AA32",
                "#5AB333",
                "#16ABA1",
                "#2E7DD9",
                "#9ECF36",
                "#DEAC07",
                "#E44144",
                "#A522BD",
                '#4488E2',
                '#646F9D',
                "#7143DE",
            ];
            data.forEach((item, index) => {
                const s_item = {
                    name: item.source_name + "总金额",
                    // value: item.total_amount,
                    value: item.value,
                    origin_value: item.total_amount,
                    color: color[index],
                    rate: item.rate,
                    label: {
                        // alignTo: "edge",
                        position: "outside",
                        formatter: `{circle|c}{name|{b}}\n{count|${item.total_amount}元}\n`,
                        labelLine: {
                            length: 20,
                        },

                        rich: {
                            count: {
                                fontSize: 12,
                                color: "rgba(0, 0, 0, 0.45)",
                                padding: [0, 0, 0, 11],
                            },
                            name: {
                                padding: [0, 0, 0, 5],
                                fontSize: 12,
                                color: "rgba(0, 0, 0, 0.65)",
                            },
                            circle: {
                                width: 6,
                                height: 6,
                                backgroundColor: color[index],
                                borderRadius: 5,
                                color: "rgba(255,255,255,0)",
                            },
                        },
                        position: 'outside'
                    },
                };
                const s_item2 = {
                    name: item.source_name + "总金额",
                    // value: item.total_amount,
                    value: item.value,
                    origin_value: item.total_amount,
                    color: color[index],
                    rate: item.rate,
                    label: {
                        normal: {
                            show: true,
                            position: "inner", // 数值显示在内部
                            formatter: "{d}%",
                            color: "#ffffff",
                        },
                    },
                };
                sData.push(s_item);
                sData2.push(s_item2);
            });
            this.getEchartsPie("container2", sData, sData2, color);
        },
        getEchartsPie(id, sData, sData2, color) {
            var dom = document.getElementById(id);
            var myChart = echarts.init(dom);
            myChart.clear();
            var option;
            var that = this;
            option = {
                color,
                title: {
                    text: "",
                },
                tooltip: {
                    trigger: "item",
                    backgroundColor: "#fffffff",
                    padding: 12,
                    formatter: function (params) {
                        let html = "";
                        html += `<div class="custom_chart_tooltip"><p class="tooltip_title"><span>${params.name}</span></p><p class="tooltip_content"><span class="chart_circle_item"><i class="chart_circle" style="background: ${params.color}"></i>${params.data.origin_value}元</span><span class="count">${params.percent}%</span></p></div>`;
                        return html;
                    },
                },
                legend: {
                    show: false,
                    icon: "rect",
                    itemWidth: 10,
                    itemHeight: 8,
                    borderRadius: 2,
                    textStyle: {
                        fontSize: 14, // 设置图例文本的字体大小为 16 像素
                        padding: [5, 0, 5, 0],
                    },
                    left: 0,
                    itemGap: 10,
                    top: 0,
                },
                left: "center",
                top: 35,
                right: 0,
                left: 0,
                bottom: 0,
                series: [
                    {
                        name: "",
                        type: "pie",
                        avoidLabelOverlap: true,
                        radius: 60,
                        top: 10,
                        labelLine: {
                            // length: 25,
                            // length2: 100,
                            // maxSurfaceAngle: 80,
                            showAbove: true,
                            lineStyle: {
                                color: "rgba(0, 0, 0, 0.25)",
                            },
                        },
                        // labelLayout: function (params) {
                        //     const isLeft = params.labelRect.x < myChart.getWidth() / 2;
                        //     const points = params.labelLinePoints;
                        //     // Update the end point.
                        //     points[2][0] = isLeft ? params.labelRect.x : params.labelRect.x + params.labelRect.width;
                        //     return {
                        //         labelLinePoints: points,
                        //     };
                        // },
                        data: sData,
                    },
                    {
                        name: "",
                        type: "pie",
                        avoidLabelOverlap: true,
                        radius: 60,
                        top: 10,
                        data: sData2,
                    },
                ],
            };
            option && myChart.setOption(option, true);
            this.myChartPie = myChart;
            this.handleResizePie();
            window.addEventListener("resize", this.handleResizePie);
        },
        handleResize() {
            if (this.resizeHandler) {
                clearTimeout(this.resizeHandler);
            }
            this.resizeHandler = setTimeout(() => {
                if (this.myChartBar) {
                    this.myChartBar.resize();
                }
            }, 100);
        },
        handleResizePie() {
            if (this.resizeHandlerPie) {
                clearTimeout(this.resizeHandlerPie);
            }
            this.resizeHandlerPie = setTimeout(() => {
                if (this.myChartPie) {
                    this.myChartPie.resize();
                }
            }, 100);
        },
        // 明细详情
        handleClickDetail(row) {
            if (this.tabActiveName == "payableSummary") {
                this.$router.push({
                    name: "PayableStatisticsDetails",
                    query: {
                        tabActiveName: this.tabActiveName,
                        entity_type: row.entity_type,
                        entity_name: row.entity_name,
                        entity_id: row.entity_id,
                        source_id: this.source_id,
                    },
                });
            } else {
                this.$router.push({
                    name: "PayableStatisticsDetails",
                    query: {
                        tabActiveName: this.tabActiveName,
                        customer_id: row.customer_id,
                        supplier_name: row.supplier_name,
                        payee_name: row.payee_name,
                        source_id: this.source_id,
                    },
                });
            }
        },
        // 查看客户详情
        handleClickCustomerDetail(customer_id, customer_name) {
            this.$router.push({
                name: "CustomerPrivateSeasDetail",
                params: {
                    isPush: true,
                },
                query: {
                    customer_id,
                    name: customer_name,
                },
            });
        },
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.handleResize);
        if (this.myChartBar) {
            this.myChartBar.dispose();
        }
        if (this.myChartPie) {
            this.myChartPie.dispose();
        }
    },
};
</script>
<style lang="scss" scoped>
@import "@/styles/m_style/finance_management.scss";

.mobile_container {
    width: 100%;
    padding: 10px 16px;
    box-sizing: border-box;
    overflow-x: hidden;
}
</style>
<style lang="scss">
.custom_chart_tooltip {
    background-color: #ffffff;
    padding: 12px;
    border-radius: 2px;
    box-shadow: 0px 2px 4px #0000003f;

    .tooltip_title {
        font-size: 12px;
        font-weight: 400;
        letter-spacing: -0.2px;
        line-height: 12px;
        color: rgba(0, 0, 0, 0.45);
    }

    .tooltip_content {
        margin-top: 12px;
        font-size: 12px;
        font-weight: 400;
        letter-spacing: -0.2px;
        line-height: 12px;
        color: rgba(0, 0, 0, 0.65);
        display: flex;
        justify-content: space-between;
        gap: 24px;

        .count {
            font-weight: 500;
        }

        .chart_circle_item {
            display: flex;
            align-items: center;

            .chart_circle {
                display: inline-block;
                vertical-align: middle;
                width: 8px;
                height: 8px;
                border-radius: 50%;
                margin-right: 9px;
            }
        }
    }
}
</style>
